import { OrganisationMember } from '@ih/app/shared/apis/interfaces';

export class FindAllOrganisationPermissionsAction {
  public static readonly type =
    '[Authorisation] FindAllOrganisationPermissionsAction';
  constructor(public readonly organisationMembers: OrganisationMember[]) {}
}
